<!-- <iframe [src]="base64" *ngIf="base64" frameborder="0" width="100%" height="100%">
</iframe> -->
<section class="content-header">
    <div class="container-fluid">
        <div class="row mb-2">
            <div class="col-sm-6">
                <h1>Detalle Pedido</h1>
            </div>
        </div>
    </div>
</section>
<section class="content">
    <div class="container-fluid" *ngIf="pedido">
        <div class="row">
            <div class="col-12">
                <div class="invoice p-3 mb-3">
                    <div class="row">
                        <div class="col-12">
                            <h4>
                                <i class="fas fa-globe"></i> SimpleLaundry
                                <small class="float-right">Fecha Ingreso: {{pedido.fecha_ingreso | date:'dd/MM/yyyy'}}</small>
                            </h4>
                        </div>
                    </div>
                    <div class="row invoice-info">
                        <div class="col-sm-4 invoice-col">
                            Datos Lavanderia
                            <address>
                                <strong>{{tenant.nombre_fantasia}}</strong><br>
                                {{tenant.direccion}}<br>
                                Teléfono: {{tenant.telefono}}<br>
                            </address>
                        </div>

                        <div class="col-sm-4 invoice-col">
                            Datos Cliente
                            <address>
                                <strong>{{pedido.cliente.nombre_completo}}</strong><br>
                                Teléfono: {{pedido.cliente.telefono}}<br>
                                Email: {{pedido.cliente.mail}}
                            </address>
                        </div>

                        <div class="col-sm-4 invoice-col">
                            <b>Pedido: {{pedido.numero_pedido_format || pedido.id_pedido_format}}</b><br>
                            <br>
                            <b>Fecha Termino:</b> {{pedido.fecha_termino | date:'dd/MM/yyyy'}}<br>
                            <b>Estado:</b> {{pedido.estado.nombre_estado}}<br>
                        </div>

                    </div>


                    <div class="row">
                        <div class="col-12 table-responsive">
                            <table class="table table-striped">
                                <thead>
                                    <tr>
                                        <th class="text-center" style="width: 40px;">Cant.</th>
                                        <th>Producto</th>
                                        <th class="text-right">Precio</th>
                                        <th class="text-right">Subtotal</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let item of pedido.detalle_pedidos">
                                        <td class="text-center" style="width: 40px;">{{item.cantidad}}</td>
                                        <td>{{item.producto.nombre}}</td>
                                        <td class="text-right">{{Func.currencyPeso(item.valor)}}</td>
                                        <td class="text-right">{{Func.currencyPeso(item.valor * item.cantidad)}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                    </div>

                    <div class="row">

                        <div class="col-md-3 col-12">
                            <p class="lead">Retiros y despachos:</p>
                            <div class="text-muted well well-sm shadow-none" style="margin-top: 10px;">
                                <div *ngIf="pedido.is_pickup">
                                    <h5>Retiro: {{pedido.fecha_pickup | date: 'dd/MM/yyyy'}}</h5>
                                    <p>Dirección: {{pedido.direccion_pickup.direccion}}</p>
                                </div>
                                <div *ngIf="pedido.is_pickup">
                                    <h5>Despacho: {{pedido.fecha_delivery | date: 'dd/MM/yyyy'}}</h5>
                                    <p>Dirección: {{pedido.direccion_delivery.direccion}}</p>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-3 col-12">
                            <div class="text-muted well well-sm shadow-none" style="margin-top: 10px;">
                                <h5>Observación:</h5>
                                <div>
                                    <p>{{pedido.observacion}}</p>
                                </div>
                            </div>
                            <div class="text-muted well well-sm shadow-none" style="margin-top: 10px;">
                                <h5>Detalle de pagos</h5>
                                <div *ngFor="let item of pedido.detalle_pagos">
                                    <p>{{item.fecha_pago | date: 'dd/MM/yyyy'}} - {{item.tipo_pago.nombre_tipopago}} - {{Func.currencyPeso(item.valor)}}</p>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-6 col-12">
                            <p class="lead">Totales</p>
                            <div class="table-responsive">
                                <table class="table">
                                    <tbody>
                                        <tr>
                                            <th style="width:50%">Subtotal:</th>
                                            <td><span
                                                *ngIf="pedido.descuento == 0">{{Func.currencyPeso(pedido.subtotal_venta)}}</span>
                                            <span
                                                *ngIf="pedido.descuento != 0"><s>{{Func.currencyPeso(summProductos)}}</s>
                                                {{Func.currencyPeso(pedido.subtotal_venta)}}</span></td>
                                        </tr>
                                        <tr>
                                            <th>Descuento{{pedido.tipo_descuento == '$' ? '' : ' (' + pedido.descuento + '%)'}}:</th>
                                            <td>{{Func.currencyPeso(summProductos - pedido.subtotal_venta)}}</td>
                                        </tr>
                                        <tr>
                                            <th>Despacho:</th>
                                            <td>{{Func.currencyPeso(pedido.valor_despacho)}}</td>
                                        </tr>
                                        <tr>
                                            <th>Total:</th>
                                            <td>{{Func.currencyPeso(pedido.total_venta)}}</td>
                                        </tr>
                                        <tr>
                                            <th>Abono:</th>
                                            <td>{{Func.currencyPeso(pedido.abono)}}</td>
                                        </tr>
                                        <tr>
                                            <th>Saldo:</th>
                                            <td>{{Func.currencyPeso(pedido.saldo)}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                    </div>


                    <div class="row no-print">
                        <div class="col-12">
                            <!-- <button type="button" class="btn btn-success float-right"><i class="far fa-credit-card"></i>
                                Gestionar pago
                            </button> -->
                            <button type="button" class="btn btn-primary float-right" style="margin-right: 5px;" (click)="GeneraPdf()">
                                <i class="fas fa-download"></i> Generar PDF
                            </button>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</section>

<ng-template #content let-modal>

    <div class="modal-header bg-dark">
        <h5 class="modal-title" id="changeStateLabel">Ticket</h5>
        <button type="button" class="close text-light" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="row justify-content-center">
            <div class="col-12">
                <iframe [src]="base64" *ngIf="base64" frameborder="0" width="100%" height="500px">
                  </iframe>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-danger" (click)="modal.dismiss('close')"><i
                class="fas fa-times"></i> Cerrar</button>
    </div>
</ng-template>